import process from 'process';
import { useQuery } from 'react-query';
import { queryKeys } from '@/queries/queryKeys';
import axios from 'axios';
import { NextSeo } from 'next-seo';
import React, { useEffect, useState } from 'react';
import Footer from '@/components/Footer/Footer';
import LandingHeader from '@/components/Header/LandingHeader';
import HeadSection from '@/components/Vacancies/HeadSection';
import Vacancy from '@/components/Vacancies/Vacancy';
import EmptyImage from '@/images/svg/emptyImage.svg';
import Image from 'next/image';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function Vacancies() {
  const url = `https://api.storyblok.com/v2/cdn/stories/page/vacancies?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data, isLoading } = useQuery(queryKeys.vacancies, () =>
    axios.get(url)
  );
  const story = data?.data?.story?.content;
  const applyNowOptions = `https://api.storyblok.com/v2/cdn/stories/apply-now-options?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data: applyNowOptionsData, isLoading: isLoadingApplyNow } = useQuery(
    queryKeys.applyNowOptions,
    () => axios.get(applyNowOptions)
  );

  const applyNow = applyNowOptionsData?.data?.story?.content;

  const [activeTab, setActiveTab] = useState<string>('All locations');
  const [vacancies, setVacancies] = useState([]);
  const [hideDesc, setHideDesc] = useState(false);

  useEffect(() => {
    if (!isLoading && story) {
      if (activeTab === 'All locations') {
        setVacancies(story.vacancies);
      } else {
        setVacancies(
          story.vacancies.filter((i: any) => i.location_tag.includes(activeTab))
        );
      }
    }
  }, [activeTab, isLoading, story]);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <NextSeo
        title='Vacancies'
        openGraph={{
          title: 'Our vacancies',
          description: 'Our vacancies',
        }}
      />
      {!isLoading && !isLoadingApplyNow && (
        <div className='landing relative overflow-hidden'>
          <LandingHeader applyNowText={applyNow.apply_now_label} />
          <div className='land-container my-12'>
            <HeadSection
              title={story.title}
              label={story.select_label}
              locations={story.location_tags}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              setHideDesc={setHideDesc}
            />
            {vacancies.length > 0 ? (
              vacancies
                .slice()
                .reverse()
                .map((i: any) => (
                  <Vacancy
                    key={i._uid}
                    title={i.title}
                    locationLabel={i.location_label}
                    locationTag={
                      activeTab === 'All locations'
                        ? i.location_tag
                        : [activeTab]
                    }
                    jobTypeLabel={i.job_type_label}
                    shortJobDescription={i.short_job_description}
                    jobTypeDescription={i.job_type_description}
                    licenseRequiredLabel={i.license_required_label}
                    licenseRequiredDescription={i.license_required_description}
                    jobDescriptionsBlocks={i.job_descriptions_blocks}
                    educationDescription={i.education_description}
                    educationLabel={i.education_label}
                    applyNow={applyNow}
                    hideDesc={hideDesc}
                    setHideDesc={setHideDesc}
                    requireSecurityGuard={i.require_security_guard}
                  />
                ))
            ) : (
              <div className='mt-12 mb-12'>
                <Image
                  src={EmptyImage}
                  height={120}
                  width={120}
                  alt='EmptyImage'
                  className='mb-2 m-auto'
                />
                <p className='text-center text-main-black text-base'>
                  Sorry, but there are no vacancies for this location.
                  <br />
                  Try to choose another location
                </p>
              </div>
            )}
          </div>
          <Footer applyNowText={applyNow.apply_now_label} />
        </div>
      )}
    </GoogleReCaptchaProvider>
  );
}
